import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Item = ({ slug, title, image, bodyContent, createdAt, author }) => {
  const { file: { url, fileName } } = image
  return (
    <div className='col-lg-4 col-md-6'>
      <div className='blog-post layout-1 box-shadow sm-mb-35px wow fadeInUp' data-wow-delay='.4s'>
        <Link to={`/post/${slug}`}>
          <div className='img-out'>
            <img width='350' height='200' src={url} alt={fileName} />
            <div className='icon-type' />
          </div>
          <div className='post-info'>
            <ul className='meta'>
              <li><span className='icon_clock_alt' />{createdAt}</li>
              <li><span className='icon_profile' />{author.name}</li>
            </ul>
            <div className='more link truncate-title'>{title}</div>
            <div className='wassf truncate-text' dangerouslySetInnerHTML={{ __html: bodyContent.childMarkdownRemark.html }} />
          </div>
        </Link>
      </div>
    </div>
  )
}

Item.propTypes = {
  image: PropTypes.shape(),
  slug: PropTypes.string,
  title: PropTypes.string,
  bodyContent: PropTypes.shape(),
  createAt: PropTypes.string,
  author: PropTypes.shape()
}

Item.defaultProps = {
  image: {},
  slug: '',
  title: '',
  bodyContent: {},
  createAt: '',
  author: {}
}

export default Item
